export const GEOBLOCKING_STATUS = {
  LOADING: 'loading',
  ENABLED: 'enabled',
  DISABLED: 'disabled',
};

export const GEOBLOCKING_STATUS_EVENT = 'geoblocking:status';

export const GEOBLOCKING_SELECTED_ZONE_COOKIE = 'selectedZone';
